import React from 'react';

import Loading from '../../common/Loading';
import _ from 'lodash';
import { Tooltip, Select, Button, DatePicker, Row, Col } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

const FormItem = Form.Item;
const { RangePicker } = DatePicker;
import { graphql, compose } from 'react-apollo';
import moment from 'moment';

import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import getEnvironment from '../../../graphql/querys/common/getEnvironment.graphql';

@compose(
  graphql(getUsuario, {
    name: 'usuario',
  }),
  graphql(getOrganismos),
  graphql(getEnvironment, {
    name: 'getEnvironment',
  })
)
class FormRangoFechas extends React.Component {
  state = {
    llamada: false,
  };
  disabledDate = fecha => {
    return fecha && fecha > moment().endOf('day');
  };

  onSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        // console.log('Received values of form: ', values);
        if (
          this.state.fechaInicio &&
          this.state.fechaFin &&
          this.state.idOrganismo
        ) {
          let fechaInicio = values.fechas[0]
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            .toDate();
          let fechaFin = values.fechas[1]
            .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
            .toDate();
          this.props.buscar(
            fechaInicio,
            fechaFin,
            values.idOrganismo,
            this.obtenerNombreOrganismo(values.idOrganismo)
          );
        }
      }
    });
  };

  onSubmitSQL = () => {
    // console.log(e.target.value);
    // console.log('ORG: ', this.state.idOrganismo);
    // console.log(this.props);
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        console.log('Received values of form: ', values);
        if (
          this.state.fechaInicio &&
          this.state.fechaFin &&
          this.state.idOrganismo
        ) {
          let fechaInicio = values.fechas[0]
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            .toDate();
          let fechaFin = values.fechas[1]
            .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
            .toDate();
          this.props.buscarSQL(
            fechaInicio,
            fechaFin,
            values.idOrganismo,
            this.obtenerNombreOrganismo(values.idOrganismo)
          );
        }
      }
    });
  };

  onGenerateReport = async () => {
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (
          this.state.fechaInicio &&
          this.state.fechaFin &&
          this.state.idOrganismo
        ) {
          const fechaInicio = values.fechas[0]
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            .toDate();
          const fechaFin = values.fechas[1]
            .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
            .toDate();

          if (this.props.generateReportDetalleCSV) {
            this.props.generateReportDetalleCSV(fechaInicio, fechaFin);
          } else if (this.props.generateReport) {
            this.props.generateReport(fechaInicio, fechaFin);
          }
        }
      }
    });
  };

  // eslint-disable-next-line no-unused-vars
  onChange = (date, dateString) => {
    this.setState({
      fechaInicio: date[0]
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .toDate(),
      fechaFin: date[1]
        .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
        .toDate(),
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.usuario && !this.state.llamada) {
      this.cambiarOrganismo(nextProps.usuario.getUsuario.organismo._id);
    }
  }

  cambiarOrganismo = idOrganismo => {
    this.setState({
      ...this.state,
      idOrganismo: idOrganismo,
      nombreOrganismo: this.obtenerNombreOrganismo(idOrganismo),
    });
  };

  obtenerNombreOrganismo = idOrganismo => {
    let nombre = '';
    let organismo = _.find(this.props.data.getOrganismos, { _id: idOrganismo });
    organismo
      ? (nombre = organismo.nombre)
      : (nombre = this.props.usuario.getUsuario.organismo.nombre);
    return nombre;
  };

  render() {
    const { data } = this.props;
    const { loading } = this.state;
    if (data.loading || loading) {
      return <Loading />;
    }

    const { getFieldDecorator } = this.props.form;
    let usuario = this.props.usuario.getUsuario;
    let environment = this.props.getEnvironment.getEnvironment;
    let fechaActual = new Date();
    let fecha2020 = new Date(2020, 0, 1);

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 18,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 4,
        },
      },
    };

    return (
      <div>
        <hr />
        <br />
        <h3 className="tituloForm">Seleccion de Rango de Fechas</h3>
        <Form
          onSubmit={this.onSubmit}
          style={{ marginTop: 50, marginRight: 40 }}
        >
          <Row>
            <Col span={16} offset={4}>
              <FormItem
                {...formItemLayout}
                label={
                  <span>
                    Rango de Fechas
                    <Tooltip title="Seleccione el rango de fechas del reporte">
                      <Icons.QuestionCircleOutlined />
                    </Tooltip>
                  </span>
                }
              >
                {getFieldDecorator('fechas')(
                  <RangePicker
                    style={{ width: 415, marginLeft: 10 }}
                    onChange={this.onChange}
                    format={'DD-MM-YYYY'}
                  />
                )}
              </FormItem>
            </Col>
          </Row>

          <Row>
            <Col span={16} offset={4}>
              <FormItem
                {...formItemLayout}
                label={
                  <span>
                    Organismo
                    <Tooltip title="Seleccione el organismo del reporte">
                      <Icons.QuestionCircleOutlined />
                    </Tooltip>
                  </span>
                }
              >
                {getFieldDecorator('idOrganismo', {
                  initialValue: usuario.organismo._id,
                })(
                  <Select
                    style={{ width: 415, marginLeft: 10 }}
                    id="organismos"
                    placeholder="Seleccione el organismo"
                    disabled={usuario.organismo._id != '00004'}
                    onSelect={valor => this.cambiarOrganismo(valor)}
                  >
                    {this.props.data.getOrganismos &&
                      this.props.data.getOrganismos.map(organismo => (
                        <Select.Option key={organismo._id}>
                          {organismo.nombre}
                        </Select.Option>
                      ))}
                  </Select>
                )}
              </FormItem>
            </Col>
          </Row>

          <FormItem {...tailFormItemLayout}>
            <Button htmlType="submit" style={{ marginLeft: '20%' }}>
              Generar Reporte Anterior {this.props.buscarSQL ? '2020' : ''}
            </Button>
            {(((usuario.rol === 'SUPERVISOR' ||
              usuario.rol === 'CONFIGURADOR' ||
              fechaActual > fecha2020) &&
              environment === 'production') ||
              environment !== 'production') &&
              this.props.buscarSQL && (
                <>
                  <Button
                    type="primary"
                    onClick={() => this.onSubmitSQL()}
                    style={{ marginLeft: 10 }}
                  >
                    <Icons.ProfileOutlined /> Generar Reporte
                  </Button>
                  {/* {this.props.generateReport && ( */}
                  <Button
                    type="primary"
                    onClick={() => this.onGenerateReport()}
                    style={{ marginLeft: 10 }}
                  >
                    <Icons.ProfileOutlined /> Generar Reporte CSV AG
                  </Button>
                  {/* )} */}
                </>
              )}
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create()(FormRangoFechas);
